import Swal from "sweetalert2";
import { v2ReactURL } from "../../utils/constant";
import { axiosFunction } from "./axiosFunction";
import { SwalFunction } from "./SwalFunction";
import { RowData } from "../../pages/Contact/MainDataTable";


export const ActiveDeactiveCustomerFunc = async (row : RowData, contactType:string, fetchData?: () => void) => {
  const result = await SwalFunction(
    "Are You Sure?",
    "You Won't Be Able To Revert This!",
    `Yes, ${row.active === 0 ? "Deactive" : "Active"} It!`,
    { icon: "warning" }
  );

  if (result.isConfirmed) {
    const response = await axiosFunction(
      `${v2ReactURL}/contact/${contactType}/${
        row.active === 0 ? "deactive" : "active"
      }/${row.contactId}`,
      "GET"
    );

    if (response.data.status) {
      Swal.fire({
        title: `${row.active === 0 ? "Deactived" : "Actived"}`,
        text: `Your Contact has been ${
          row.active === 0 ? "Deactived" : "Actived"
        } Successfully.`,
        icon: "info",
      });

    
      fetchData?.();
     
    }
  }
};
